import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  Loading
} from "./components";
import {
  fetchGetUser
} from "../store/UserStore";
import {
  refreshContracts,
  setContract
} from "../store/ContractsStore";
import AppRoutes from "./AppRoutes";
import AuthRoutes from "./AuthRoutes";

const RootRoutes = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const contractsStore = useSelector((state) => state.contracts || { contracts: [], contract: null, isLoading: false });
  const contractsFetchedRef = React.useRef(false);

  React.useEffect(() => {
    dispatch(fetchGetUser());
  }, [dispatch]);
  React.useEffect(() => {
    if (!user.isLoading && user.user && !contractsFetchedRef.current) {
      contractsFetchedRef.current = true;
      dispatch(refreshContracts());
    }
  }, [user.isLoading, user.user, dispatch]);
  React.useEffect(() => {
    if (!contractsStore.contract && contractsStore.contracts.length > 0) {
      dispatch(setContract(contractsStore.contracts[0]));
    }
  }, [contractsStore.contract, contractsStore.contracts, dispatch]);

  if (user.isLoading) {
    return <Loading/>
  }
  if (!user.isLoading && !user.user) {
    return <AuthRoutes/>
  }
  if (contractsStore.isLoading || !contractsFetchedRef.current) {
    return <Loading/>
  }
  return <AppRoutes/>
}

export default RootRoutes
